
const STICKY_CASES = [
  'a',
  'A',
  'k',
  'K',
  'v',
  'V',
  've',
  'Ve',
  'o',
  'O',
  'i',
  'I',
  'na',
  'Na',
  'z',
  'Z',
  'za',
  'Za',
  'the',
  'The',
];

// todo - set array of breaking words and do replace loop
export const formatText = (text) => {
  let tempString = text;
  for (let i = 0; i < STICKY_CASES.length; i += 1) {
    const rex = new RegExp(` ${STICKY_CASES[i]} `, 'g');
    tempString = tempString.replace(rex, ` ${STICKY_CASES[i]}\u00A0`);
  }
  return tempString;
};



// WEBPACK FOOTER //
// ./src/utils/TextHelper.js